import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=45e7745d&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=45e7745d&prod&scoped=true&lang=scss&"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&id=45e7745d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e7745d",
  null
  
)

export default component.exports